/* eslint-disable no-unused-vars */
import { t } from "i18next";
import React, { useEffect, useState } from "react";
import { BottomDiv } from "../../atoms/BottomNav";
// import { Text } from "../../atoms/TextField";
//import MenuIcon from "../../molecule/MenuIcon/MenuIcon";
//import { Div } from "../../atoms/Div";
import {ConnectIconHeaderMbl, HelpIconHeaderMbl, ConnectText, NewsfeedIconHeaderMlb, HomeIcon} from "../../atoms/Header";
import WhiteConnectIcon from "../../../images/connecticon.svg";
import ConnectIconGrey from "../../../images/message_icon_grey.svg";
import ConnectIconOrange from "../../../images/message_icon_orange.svg";
import HomeIconGrey from "../../../images/home_icon_grey.svg";
import HomeIconOrange from "../../../images/home_icon_orange.svg";
import NewsfeedIconGrey from "../../../images/newsfeed_black.svg";
import newsfeed_orange from "../../../images/newsfeed_orange.svg";
import newsfeed_white from "../../../images/newsfeed_white.svg";
import getHelpIconGrey from "../../../images/help_icon_grey.svg";
import getHelpIconOrange from "../../../images/help_icon_orange.svg";
import getHelpIconWhite from "../../../images/help_icon_white.svg";
import * as Utilites from "@mywvglobal-shared/mywv-shared/common/utilities";
import {GiveIconMbl} from "../../molecule/GiveIcon/Index";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { isMobile } from "../../../utilities/deviceUtilities";
import useAlert from "../../../hooks/useAlert";

const BottomTabs=(props)=>{
  //const { persistItemsReducer } = useSelector((state) => state);
    const { loginReducer } = useSelector((state) => state);
    const { worldReducer } = useSelector((state) => state);
    const navigate = useNavigate();
    const { setAlert } = useAlert();
    const params=useParams();
    const [displayGive, setdisplayGive] = useState(false);
    const [displaynewsfeed, setDisplaynewsfeed] = useState(false);
    const [showNoSponsorshipMessage,setShowNoSponsorshipMessage] = useState(false);
    const ifSponsoredChildAvailable = (worldReducer?.childList?.length > 0) && (worldReducer?.childList?.some(child => !!child.childCode));

    const checkSponsorship = () =>{
      if(!ifSponsoredChildAvailable) {
        setShowNoSponsorshipMessage(!showNoSponsorshipMessage);
        return;
      }  
    }
    const navigateConnect=()=>{
      if(!ifSponsoredChildAvailable) {
        setShowNoSponsorshipMessage(!showNoSponsorshipMessage);
        return;
      }  
      if(params?.childcode){
        navigate(`/connect/${params?.childcode}`)
      }else{
        navigate(`/connect/${(props?.selectedChild)}`)
      } 
    }

    const navigateCommunityHome=()=>{
      if(!ifSponsoredChildAvailable) {
        setShowNoSponsorshipMessage(!showNoSponsorshipMessage);
        return;
      }
      if(params?.childcode){
        navigate(`/communityhomeview/${params?.childcode}`)
      }else{
        navigate(`/communityhomeview/${(props?.selectedChild)}`)
      }
    }
    //cta code change start
    const navigateFeed = () => {
      if (!ifSponsoredChildAvailable) {
        setShowNoSponsorshipMessage(!showNoSponsorshipMessage);
        return;
      }
      navigate("/newsandstories", { state: { childcode: props?.selectedChild } });
    };
    const navigateHelp = () => {
      if (!ifSponsoredChildAvailable) {
        setShowNoSponsorshipMessage(!showNoSponsorshipMessage);
        return;
      }
      navigate("/getHelp", { state: { childcode: props?.selectedChild } });
    };
    //cta code change end
    useEffect(() => {
      if(Utilites.GetSOBasedConfiguration(
        loginReducer?.getSOConfiguration,
        "Gift",
        "SendAGift",
        )||(Utilites.GetSOBasedConfiguration(
            loginReducer?.getSOConfiguration,
            "Gift",
            "SendAGift",
        )&&Utilites.GetSOBasedConfiguration(
            loginReducer?.getSOConfiguration,
            "Gift",
            "Donate",
        ))){setdisplayGive(true)}

        if(isMobile(1199) && Utilites.GetSOBasedConfiguration(
          loginReducer?.getSOConfiguration,
          "StoriesInBottomNavBar",
          "",
        )){
          setDisplaynewsfeed(true)
        }

    }, [loginReducer?.getSOConfiguration]);

    useEffect(() => {
      if (showNoSponsorshipMessage) {
          //setIsErrorOccured(false);
          const IsChildAvaialble = worldReducer?.childList?.some((e) => e?.isSponsor == false);
          if (!IsChildAvaialble) {
              setAlert(t("NoSponsorshipsFound"),  
              // " ", //cta code change
              t("NoSponsorshipDescription"),
              t("NoSponsorshipDescription2", { AccountDetails: t("AccountDetails"), FindNewChild: t("FindNewChild") }),
              [t("AccountDetails"), t("FindNewChild")],
              "error",false, false, false)
              // "error",false, false, false, retryButtonClicked)
          }
      }
      }, [worldReducer, showNoSponsorshipMessage]); 

    return(
        <>
        <BottomDiv ref={element => { 
              if (element && isMobile(1199)) element.style.setProperty("display", "flex", "important"); 
            }}
            nobg={props?.community}
            station={props?.station}
            >
        {/* {!props.community &&<Text mblhomedisclaimer>{t("ChooseAChild")}</Text>} */}
          {/* {props.community && */}
          {<HomeIcon community={props?.community} onClick={()=> navigateCommunityHome() }> 
            {window.location.pathname.includes("home")|| window.location.pathname.includes("communityhomeview") || 
            window.location.pathname.includes("childprofile") || window.location.pathname.includes("childcommunity")||
            window.location.pathname.includes("community/station")? 
            <img src={HomeIconOrange} alt="" /> :
             <img src={HomeIconGrey} alt="" />}
             <ConnectText community={props?.community}>{t("Home")}</ConnectText>
          </HomeIcon>}
           {/* {props.connect || props.home || props.gift || props.station ? null :  */}
          {props.home || !(worldReducer?.childList?.length > 0) ? null :
            <ConnectIconHeaderMbl onClick={()=> navigateConnect()}>
                    {window.location.pathname.includes("/connect") ?  <img src={ConnectIconOrange} alt= ""/> : 
                    <img src={props?.community ? WhiteConnectIcon : ConnectIconGrey} alt= ""/> }
                    <ConnectText community={props?.community}>{t("Connect")}</ConnectText>
            </ConnectIconHeaderMbl>}
            
            
            {/* {!props?.help &&
              <HelpIconHeaderMbl onClick={()=>navigate("/getHelp")}>
                      <img src={getHelpIcon} alt= ""/> 
                      <ConnectText>{t("GetHelp")}</ConnectText>
              </HelpIconHeaderMbl>
            } */}
            { displayGive &&
                    // !props?.station && !props?.gift && 
                    <GiveIconMbl checkSponsorship={checkSponsorship} community={props?.community} selectedChild={props?.selectedChild} suggestions={props?.searchChildData}/>
                  }

          {displaynewsfeed && (
          //cta code change  - onclick added
          <NewsfeedIconHeaderMlb onClick={navigateFeed}>  
            {window.location.href.includes("newsandstories") ? (
              <img src={newsfeed_orange} alt="" />
            ) : (
              <img
                src={props?.community ? newsfeed_white : NewsfeedIconGrey}
                alt=""
              />
            )}
            <ConnectText community={props?.community}>
              {t("Newsfeed")}
            </ConnectText>
          </NewsfeedIconHeaderMlb>
        )}
 {/*cta code change  - onclick added */}
              <HelpIconHeaderMbl onClick={()=>navigate("/getHelp", {state: {childcode: props?.selectedChild}} )}>
                      {window.location.pathname.includes("getHelp")? <img src={getHelpIconOrange} alt= ""/> :
                      <img src={props?.community? getHelpIconWhite : getHelpIconGrey} alt= ""/> }
                      <ConnectText community={props?.community}>{t("GetHelp")}</ConnectText>
              </HelpIconHeaderMbl>
            {/* {persistItemsReducer?.isLoggedIn ? <Div mblMenuHome>
              <MenuIcon bottom communityHome={props?.communityHome}/>
            </Div> : null} */}
        
        </BottomDiv>
        </>
    )

}

export default BottomTabs;